export default __webpack_public_path__ + "static/shopsmart_list-71f2af432285891d08587f1ffbf02e1c.png";